import React from 'react'

/**
 * @param {Object} props
 * @param {number | string} [props.x] Horizontal spacing
 * @param {number | string} [props.y] Vertical spacing
 * @returns {React.ReactElement} Div with the specified spacing
 */
const Spacer = ({ x = 0, y = 0 }) => <div style={{ width: x, height: y }} />

export default Spacer
